/**
 * Stable CSS class names for E2E — pages/SiteManagement/AuthorizationManage.
 * Containers use `authorization-manage__<element>`; inputs and user-interactable
 * controls use `authorization-manage-input--<name>`.
 */
export const AM = {
    page: 'authorization-manage-page',
    root: 'authorization-manage',

    header: 'authorization-manage__header',
    titleBox: 'authorization-manage__title-box',
    title: 'authorization-manage__title',

    backBox: 'authorization-manage__back-box',
    btnBack: 'authorization-manage-input--button-back',

    searchPaper: 'authorization-manage__search-paper',
    inputSearch: 'authorization-manage-input--search',

    gridPaper: 'authorization-manage__grid-paper',
    grid: 'authorization-manage__grid',

    /* --- Grid cells ---------------------------------------------------- */
    cellRoute: 'authorization-manage__cell-route',
    cellRouteText: 'authorization-manage__cell-route-text',
    cellRouteTooltip: 'authorization-manage__cell-route-tooltip',
    btnCopyRoute: 'authorization-manage-input--button-copy-route',
    cellMethod: 'authorization-manage__cell-method',
    cellMethodBadge: 'authorization-manage__cell-method-badge',
    cellMethodBadgePost: 'authorization-manage__cell-method-badge--post',
    cellMethodBadgePut: 'authorization-manage__cell-method-badge--put',
    cellMethodBadgeDelete: 'authorization-manage__cell-method-badge--delete',
    cellMethodBadgeGet: 'authorization-manage__cell-method-badge--get',
    cellMethodBadgePatch: 'authorization-manage__cell-method-badge--patch',
    cellActive: 'authorization-manage__cell-active',
    inputCellActiveSwitch: 'authorization-manage-input--cell-active-switch',
    cellActiveProgress: 'authorization-manage__cell-active-progress',
} as const;

export const amCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
